/* eslint-disable */

const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout2.vue')), 'base')

const center = r =>
  require.ensure(
    [],
    () => r(require('@/modules/personCenter/center.vue')),
    'personCenter'
  )

const centerPage = [
  {
    path: '/psersonCenter',
    name: 'psersonCenter',
    component: Layout,
    hidden: true,
    meta: {
      id: '7865c39e0048483aa8cf54e42002ed4b',
      auth: true
    },
    redirect: '/psersonCenter/center',
    children: [
      {
        path: '/psersonCenter/center',
        name: 'center',
        component: center,
        meta: {
          id: '274f6fc99d8a46c285e401df36f9fdb7',
          auth: true
        }
      }
    ]
  }
]
export default centerPage



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/personCenter.js